<script setup lang="ts">
import type { IVBtnProps } from '@/types/components/vBtn';
import { useSlots } from 'vue';
import { VBtn } from 'vuetify/components';

const slots = useSlots();
const props = defineProps<IVBtnProps>();
</script>

<template>
    <v-btn v-bind="props" :color="props.color ?? 'secondary'">
        <template v-for="(_slot, name) in slots" #[name]="slot">
            <slot :name="name" v-bind="slot"></slot>
        </template>
    </v-btn>
</template>

<style scoped>
:deep(.v-btn__content) {
    font-family: var(--font-family) !important;
    letter-spacing: 0;
    font-size: 14px;
    font-weight: 700;
    text-transform: none;
}

.v-btn {
    margin-bottom: 10px;
}
</style>
